<div *ngIf="supplierInfo">
  <!--    <div class="supplier-info ui-g">-->
  <!--        <span class="supplier-classification ui-g-3" [ngClass]="{'supplier-classification-new':supplierInfo.supplierOperationalData.classification === 'New',-->
  <!--                         'supplier-classification-plated':supplierInfo.supplierOperationalData.classification === 'Plated'}">{{ supplierInfo.supplierOperationalData.classification }}</span>-->
  <!--        <span class="supplier-name ui-g-6">{{ supplierInfo.supplierName }}</span>-->
  <!--        <span class="supplier-telephone ui-g-3"><a href="tel:{{supplierInfo.telephone}}">{{supplierInfo.telephone}}</a></span>-->
  <!--    </div>-->
  <!--style="margin-right: 8px; padding-left: 15px;"-->
  <div class="flex flex-wrap supplier-info">
    <div class="flex-grow-1">
      <span class="text-bold">{{ supplierInfo.supplierName }}</span>
      <span class="supplier-telephone"
        ><a href="tel:{{ supplierInfo.telephone }}"
          ><i class="fa fa-phone-square" style="padding-left: 15px; opacity: 0.7"></i>&nbsp;{{
            supplierInfo.telephone
          }}</a
        ></span
      >
    </div>
    <div class="flex-shrink-1">
      <span *ngIf="supplierInfo.supplierOperationalData != null" class="text-gray">{{
        supplierInfo.supplierOperationalData.classification
      }}</span>
      <img
        *ngIf="
          supplierInfo.supplierOperationalData != null &&
          supplierInfo.supplierOperationalData.isTransporter
        "
        src="assets/images/transported_active.png"
        class="operational-data-transporter"
        pTooltip="This supplier has transporter capability"
      />
      <span
        *ngIf="
          supplierInfo.supplierOperationalData != null &&
          supplierInfo.supplierOperationalData.classification == 'Plated'
        "
      >
        <span class="plated">PLATED</span>
      </span>

      <span
        *ngIf="
          supplierInfo.supplierOperationalData != null &&
          supplierInfo.supplierOperationalData.classification == 'New'
        "
      >
        <span class="star">
          <span class="greenstar">
            <i class="fa fa-star"></i>
          </span>
        </span>
      </span>

      <span
        *ngIf="
          supplierInfo.supplierOperationalData != null &&
          supplierInfo.supplierOperationalData.classification == 'Operational'
        "
      >
        <span class="star">
          <span class="goldstar">
            <i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>
          </span>
        </span>
      </span>
    </div>
  </div>

  <supplier-availability-calendar
    [availabilityExceptions]="supplierInfo.supplierAvailabilityExceptions"
    [dayData]="dayData"
    (availabilityExceptionsChanged)="onAvailabilityExceptionsChanged($event)"
  >
  </supplier-availability-calendar>
</div>
